import Box from '@mui/material/Box';
import { radius } from '@/shared/theme';
import logoUrl from './mydent-logo.png';

interface LogoProps {
  /** `plaque`: white badge for dark surfaces (sidebar); `mini`: square badge; `plain`: image only. */
  variant?: 'plaque' | 'mini' | 'plain';
  height?: number;
}

/** "my dent | zahnärzte" wordmark. */
export function Logo({ variant = 'plain', height = 21 }: LogoProps) {
  const img = (
    <Box
      component="img"
      src={logoUrl}
      alt="my dent zahnärzte"
      sx={{ display: 'block', height, width: 'auto' }}
    />
  );

  if (variant === 'plain') return img;

  const badge = { background: '#FFFFFF' };

  if (variant === 'mini') {
    // Crops the wordmark to its "my" glyph, as in the prototype's collapsed sidebar.
    return (
      <Box
        sx={{
          ...badge,
          width: 46,
          height: 46,
          flex: 'none',
          borderRadius: radius.control,
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          '& img': { height: 24, ml: '1px' },
        }}
      >
        {img}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        ...badge,
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: radius.sm,
        px: 1.5,
        py: '7px',
      }}
    >
      {img}
    </Box>
  );
}
